export const CLIENT_ID = "AVSeq0k_owtwMy5PpAUMqv8g6Z9qeqdlmT5ucFVNJ1DHd9eZyyzspNBNl4LE_fDfpFsvaPIVoZkl0aFE"
export const APP_SECRET = "EHyjKfOGmlKUOF-l-_EUIazEEr_5sYTFdltjKDxPwGa5a5iT5Nvc3Ir2m3t_zlXLOu1vpoPNb2tWneo3"

